import {
  ICourseNode,
  ISimplifiedNode,
} from '../components/ingestion/IngestedTree'
import { NodeType } from 'shared/types/ingestion'
import { getAPIRequest } from 'infrastructure/api'
import { ISubject } from '../components/ingestion/Utility'

type forCounting = ISimplifiedNode | ICourseNode

export function countNodeTypes(tree: forCounting) {
  const trackTypes = (tree: forCounting, count: { [key: string]: number }) => {
    if (!count[tree.type]) count[tree.type] = 0
    count[tree.type] += 1
    if ('nodes' in tree) {
      tree.nodes?.forEach((n) => trackTypes(n, count))
    }
    return count
  }
  return {
    ...trackTypes(tree, {}),
    questions: countQuestionTypes(tree),
  }
}

export function allNodesOfType<T extends ISimplifiedNode>(
  type: string,
  tree: forCounting,
) {
  const getTypes = (tree: forCounting, nodes: forCounting[]) => {
    if (!tree) return nodes
    if (tree.type === type) {
      nodes.push(tree)
    }
    if ('nodes' in tree) {
      tree.nodes?.forEach((n) => getTypes(n, nodes))
    }
    return nodes
  }
  return getTypes(tree, []) as T[]
}

function countQuestionTypes(tree: forCounting) {
  const trackTypes = (tree: forCounting, count: { [key: string]: number }) => {
    if (tree.type === NodeType.Question) {
      const qType = String(tree.data.type)
      if (!count[qType]) count[qType] = 0
      count[qType] += 1
    }
    if ('nodes' in tree) {
      tree.nodes?.forEach((n) => trackTypes(n, count))
    }
    return count
  }
  return trackTypes(tree, {})
}

/**
 * @deprecated
 */
function getSubjects() {
  return getAPIRequest<{ subjects: ISubject[] }>('/api/subjects').then(
    (resp) => {
      return resp.subjects.reduce(
        (acc: { [key: string]: ISubject }, subject) => {
          acc[subject.subject_name] = subject
          return acc
        },
        {},
      )
    },
  )
}

/**
 * @deprecated
 */
export async function mapSubject(subject: string) {
  return getSubjects().then((subjects) => {
    return subjects[subject]
  })
}
